import(/* webpackMode: "eager" */ "/vercel/path0/Website/app/(home)/discover/discover.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/Website/node_modules/next/dist/client/link.js")